export default "__VITE_ASSET__ad1c8442__"